module.exports = __webpack_public_path__ + "img/26.9bdc85a7.png";